import React from 'react';
const steps = [{
  num: 1,
  text: 'Accedés al material inmediatamente.'
}, {
  num: 2,
  text: 'Revisás todo el contenido.'
}, {
  num: 3,
  text: 'Evaluás si realmente te aporta valor.'
}];
export function Guarantee() {
  return <section className="bg-[#0B0B12] pt-6 pb-6 px-5 relative overflow-hidden" data-id="element-153">
      <div className="blur-circle bg-brand-gold/5 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20" data-id="element-154" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-155">
        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-156">
          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-10 uppercase tracking-tight" data-id="element-157">
            🛡️ GARANTÍA TOTAL DE 7 DÍAS
          </h2>
          <p className="text-center text-slate-400 mb-8 font-bold uppercase tracking-widest text-xs" data-id="element-158">
            Probalo 7 días sin riesgo. Así funciona:
          </p>

          <div className="space-y-4 mb-10" data-id="element-159">
            {steps.map(step => <div key={step.num} className="flex items-center gap-6 bg-white/5 border border-white/10 rounded-2xl px-6 py-4 shadow-xl transition-all hover:bg-white/10" data-id="element-160">
                <div className="bg-brand-gold text-black text-sm font-black w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 shadow-[0_0_15px_rgba(212,176,106,0.3)]" data-id="element-161">
                  {step.num}
                </div>
                <span className="text-base font-black text-slate-200 uppercase tracking-tight" data-id="element-162">
                  {step.text}
                </span>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-brand-gold/10 to-transparent border border-brand-gold/20 rounded-2xl p-8 text-center" data-id="element-163">
            <p className="text-sm text-slate-400 mb-3 font-bold uppercase tracking-widest" data-id="element-164">
              Si en 7 días sentís que esto NO era lo que esperabas:
            </p>
            <p className="md:text-3xl font-black gold-text-gradient mb-2 text-[18px] uppercase tracking-tighter" data-id="element-165">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-[10px] text-slate-500 font-black uppercase tracking-[0.2em]" data-id="element-166">
              Sin vueltas. Sin discusiones. Sin complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}